import { selectOrganisationStatisticsQueryOptions } from "@/features/admin/api/selectOrganisationsStatistics";
import OrganisationStatisticsTable from "@/features/admin/components/OrganisationsStatisticsTable";
import { organisationBreadcrumbTrail } from "@/features/admin/constants/organisationNav";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

const OrganisationsAdminPage = () => {
    useNav(organisationBreadcrumbTrail("Statistics"));

    const { orgStats } = Route.useLoaderData();
    return (
        <div className="w-full min-w-0">
            <OrganisationStatisticsTable organisationStatistics={orgStats} />
        </div>
    );
};

export const Route = createFileRoute("/_app/admin/organisation/statistics")({
    component: OrganisationsAdminPage,
    loader: async ({ context }) => {
        const orgStats = await context?.queryClient.ensureQueryData(selectOrganisationStatisticsQueryOptions());
        return { orgStats };
    },
});
